import GroupTable from '@/components/group/GroupTable';

export default function Group() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<GroupTable />
		</div>
	);
}
